import { EFilterStatus, ESubmitStatus } from "@/modules/helpers/enum"

export const SUBMISSION_STATUS_CONTENT: Record<ESubmitStatus, string> = {
  [ESubmitStatus.APPLIED]: "Chờ nhận hàng",
  [ESubmitStatus.BRAND_APPROVED]: "Chờ nhận hàng",
  [ESubmitStatus.FINISHED]: "Đã hoàn thành",
  [ESubmitStatus.REJECTED]: "Nhãn hàng từ chối",
  [ESubmitStatus.WAITING]: "Đang chờ phản hồi",
  [ESubmitStatus.WORKING]: "Đã được duyệt",
  [ESubmitStatus.NOT_ATTACH_LINK]: "Chưa gắn liên kết",
  [ESubmitStatus.PREVIOUSLY_RECEIVED]: "Nhãn hàng gửi trực tiếp",
  [ESubmitStatus.NOT_AUTHORIZED_ORDER_SAMPLE]: "Chưa ủy quyền đặt hàng",
  [ESubmitStatus.OVERDUE]: "Quá hạn",
  [ESubmitStatus.PENDING_ACCEPTANCE]: "Đang đợi nghiệm thu",
  [ESubmitStatus.PAYMENT_COMPLETED]: "Đã thanh toán",
  [ESubmitStatus.ACCEPTED_ACCEPTANCE]: "Đã nghiệm thu",
  [ESubmitStatus.REJECTED_ACCEPTANCE]: "Từ chối nghiệm thu"
}

export const SUBMISSION_TABS = [
  {
    value: "ALL",
    label: "Tất cả"
  },
  {
    value: EFilterStatus.REMINDER,
    label: "Gấp",
    textClassName: "!text-red-500",
    containerClassName: "!bg-red-500/10"
  },
  {
    value: EFilterStatus.OVERDUE,
    label: "Quá hạn"
  },
  {
    value: EFilterStatus.INVITED_RECEIVE_SAMPLE,
    label: "Đợi phản hồi"
  },
  {
    value: EFilterStatus.WORKING,
    label: "Duyệt - Chờ nhận hàng"
  },
  {
    value: EFilterStatus.FINISHED,
    label: "Đã hoàn thành"
  },
  {
    value: EFilterStatus.REJECTED,
    label: "Từ chối"
  }
]

export enum EReasonRejectAcceptance {
  VIDEO_IS_LATE = "VIDEO_IS_LATE",
  VIDEO_IS_WRONG_LINK = "VIDEO_IS_WRONG_LINK",
  VIDEO_IS_NOT_ATTACH_SHOP_CART = "VIDEO_IS_NOT_ATTACH_SHOP_CART",
  VIDEO_IS_ATTACH_WRONG_SHOP_CART = "VIDEO_IS_ATTACH_WRONG_SHOP_CART"
}

export const REASON_REJECT_ACCEPTANCE_MESSAGE: Record<EReasonRejectAcceptance, string> = {
  [EReasonRejectAcceptance.VIDEO_IS_LATE]: "Bài đăng trễ hạn",
  [EReasonRejectAcceptance.VIDEO_IS_WRONG_LINK]: "Gắn sai link bài đăng",
  [EReasonRejectAcceptance.VIDEO_IS_NOT_ATTACH_SHOP_CART]: "Video không gắn giỏ hàng",
  [EReasonRejectAcceptance.VIDEO_IS_ATTACH_WRONG_SHOP_CART]: "Video gắn sai giỏ hàng"
}

export const REFRESH_SAMPLE_APPLICATION_MESSAGE = {
  REFRESH_SAMPLE_APPLICATION_NOT_FOUND: "Chưa tìm thấy yêu cầu mẫu"
} as const
